import { useState } from "react";
import { requestAdminAPI } from "../../api/posh-api";
import Modal from "../UI/Modal";
import Heading from "../UI/Heading";
import DetailPair from "../UI/DetailPair";
import LoadingSpinner from "../UI/LoadingSpinner";
import { MdClose } from "react-icons/md";

/** ========================================================================
 * * ADD LENDER MODAL
 * ========================================================================== */
export default function AddLenderModal({ open, setOpen, refresh }) {
  const [loading, setLoading] = useState(false);
  const submitHandler = async () => {
    try {
      setLoading(true);
      const payload = {
        name: document.getElementById("name").value,
        contact: document.getElementById("contact").value,
        email: document.getElementById("email").value,
        phone: document.getElementById("phone").value,
        address: document.getElementById("address").value,
      };
      await requestAdminAPI("add-lender", payload);
      refresh();
      setOpen(false);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };
  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="modal max-w-[600px]">
        <Heading
          title="Add Lender"
          isBackArrow={false}
          text="Use this form to add a new lender."
        >
          <MdClose className="icon" onClick={() => setOpen(false)} />
        </Heading>
        <div className="info lg:grid-cols-2">
          <DetailPair
            label="Complete Lender Name"
            edit={true}
            inputOptions={{
              id: "name",
            }}
          />
          <DetailPair
            label="Contact Person Name"
            edit={true}
            inputOptions={{
              id: "contact",
              placeholder: "optional",
            }}
          />
          <DetailPair
            label="Contact Email"
            edit={true}
            inputOptions={{
              id: "email",
              placeholder: "optional",
            }}
          />
          <DetailPair
            label="Contact Phone"
            edit={true}
            inputOptions={{
              id: "phone",
              placeholder: "optional",
            }}
          />
          <div className="lg:col-span-2">
            <DetailPair
              label="Lender Address"
              edit={true}
              inputOptions={{
                id: "address",
                placeholder: "optional",
              }}
            />
          </div>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <div className="btn-primary" onClick={submitHandler}>
              Confirm
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
